//お気に入りフィルタリング
export default function () {
	const listEl = document.getElementById('js-bookmark');

	function removeHide(items) {
		[].forEach.call(items, function(item) {
			item.classList.remove('is-hide');
		});
	}
	function seasonReset(type){
		const items = document.querySelectorAll('#js-bookmark .js-item');
		listEl.classList.add('is-changing');
		setTimeout(function() {
			[].forEach.call(items, function(item) {
				item.classList.remove('is-off');
			});
			listEl.classList.remove('is-changing');
		},300);
	}
	function seasonFiltering(type){
		const items = document.querySelectorAll('#js-bookmark .js-item');
		const choiceItems = document.querySelectorAll('#js-bookmark .'+type);
		//処理開始で非表示
		listEl.classList.add('is-changing');
		setTimeout(function() {
			[].forEach.call(items, function(item) {
				item.classList.add('is-off');
			});
			[].forEach.call(choiceItems, function(item) {
				item.classList.remove('is-off');
			});
			//処理終了で表示
			listEl.classList.remove('is-changing');
		},300);
	}

	function filtering(type) {
		const items = document.querySelectorAll('#js-bookmark .js-item');
		//処理開始で非表示
		listEl.classList.add('is-changing');
		setTimeout(function() {
			//商品のタイプでフィルタリング
			if(type == 'kr_kayanoya' || type == 'kr_yasai') {
				const choiceItems = document.querySelectorAll('#js-bookmark .'+type);
				[].forEach.call(items, function(item) {
					item.classList.add('is-hide');
				});
				[].forEach.call(choiceItems, function(item) {
					item.classList.remove('is-hide');
				});
			}
			//ソート
			if(type == 'newer') {
				removeHide(items);
				[].slice.call(items)
					.map(function(v){
							var value = v.dataset.date;
							console.log(value);
							return { dom: v, value: value };
					})
					.sort(function(a,b){ return b.value - a.value; })
					.forEach(function(v){ listEl.appendChild(v.dom); });
			}
			//ソート
			if(type == 'older') {
				removeHide(items);
				[].slice.call(items)
					.map(function(v){
							var value = v.dataset.date;
							console.log(value);
							return { dom: v, value: value };
					})
					.sort(function(a,b){ return a.value - b.value; })
					.forEach(function(v){ listEl.appendChild(v.dom); });
			}
			//処理終了で表示
			listEl.classList.remove('is-changing');
		},300);
	}

	listEl.addEventListener('bookmarkReady', function(e) {
		const btns = document.querySelectorAll('.js-bookmark-filter');
		const seasonBtns = document.querySelectorAll('.js-season-filter');
		[].forEach.call(btns, function(btn) {
			btn.onclick = function(e) {
				[].forEach.call(btns, function(btn) {
					btn.classList.remove('is-active')
				});
				e.currentTarget.classList.add('is-active')
				filtering(e.currentTarget.value);
			}
		});
		[].forEach.call(seasonBtns, function(btn) {
			btn.onclick = function(e) {
				const el = e.currentTarget;
				if(el.classList.contains('is-active')) {
					seasonReset();
					el.classList.remove('is-active')
				} else {
					[].forEach.call(seasonBtns, function(btn) {
						btn.classList.remove('is-active')
					});
					el.classList.add('is-active')
					seasonFiltering(el.value);
				}
			}
		});
	});
}
